<div
  class="payee-popup-wrapper"
  [style.width]="width()"
>
  @if (hasTitle) {
    @if (titleTemplateRef) {
      <div
        class="payee-popup-title"
        mat-dialog-title
      >
        <ng-container [ngTemplateOutlet]="titleTemplateRef"></ng-container>
      </div>
    } @else {
      <h1
        class="payee-popup-title"
        mat-dialog-title
      >
        {{ title() }}
      </h1>
    }
  }

  @if (hasDescription) {
    <div class="payee-popup-description">
      @if (descriptionTemplateRef) {
        <ng-container [ngTemplateOutlet]="descriptionTemplateRef"></ng-container>
      } @else {
        <span color="grey-medium">{{ description() }}</span>
      }
    </div>
  }

  <ng-content></ng-content>

  <ng-template #defaultSubmit>
    @if (onSubmit(); as submit) {
      <button
        type="button"
        payee-button
        width="max"
        (click)="submit()"
      >
        Rendben
      </button>
    }
  </ng-template>

  <ng-template #defaultCancel>
    @if (onCancel(); as cancel) {
      <button
        type="button"
        payee-button
        color="white"
        width="max"
        [isBorderButton]="true"
        (click)="cancel()"
      >
        Mégse
      </button>
    } @else if (!cancelTemplateRef) {
      <button
        type="button"
        payee-button
        color="white"
        width="max"
        mat-dialog-close
        [isBorderButton]="true"
      >
        Mégse
      </button>
    }
  </ng-template>

  <div
    class="payee-popup-actions"
    mat-dialog-actions
    [align]="stackedActions() ? 'center' : 'end'"
    [class.stacked]="stackedActions()"
  >
    <ng-container [ngTemplateOutlet]="submitTemplateRef || defaultSubmit"></ng-container>
    <ng-container [ngTemplateOutlet]="cancelTemplateRef || defaultCancel"></ng-container>
  </div>
</div>
